const DataTransmissionTableRecord = ({
    flowMeterName,
    date,
    min
}) => {
    const handleDateRange = (date) => {
        const baseMin = min;
        const now = new Date();
        const diffMs = now - new Date(date);
        const diffMin = diffMs / (1000 * 60);

        if (diffMin < baseMin) {
            return circleGreen();
        }

        if (diffMin >= baseMin && diffMin < baseMin*2) {
            return circleYellow();
        }

        return circleRed();
    }

    const circleGreen = () => {
        return (
            <td>
                <span className="circle-div-wrapper">
                    <div className="circle-green"/>
                </span>
            </td>
        )
    }
    const circleYellow = () => {
        return (
            <td>
                <span className="circle-div-wrapper">
                    <div className="circle-yellow"/>
                </span>
            </td>
        )
    }
    const circleRed = () => {
        return (
            <td>
                <span className="circle-div-wrapper">
                    <div className="circle-red"/>
                </span>
            </td>
        )
    }
   
    return (
        <tr>
            <td>{flowMeterName}</td>
            {handleDateRange(date)}
            <td>
                {new Date(date).toLocaleString("pl-PL", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit"
                })}
                &nbsp;&nbsp;
                {new Date(date).toLocaleString("pl-PL", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit"
                })}
            </td>
        </tr>
    )
}

export default DataTransmissionTableRecord;